import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add-small",
  "use": "icon-add-small-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-add-small\"><path d=\"M12 7.5H8.5V4h-1v3.5H4v1h3.5V12h1V8.5H12z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol